module.exports = __webpack_public_path__ + "static/media/logo-pajakku-light.7ca1f069.svg";